<script lang="ts">
	export let title: string;
</script>

<section class="text-block">
	<h3 class="headline-m">{title}</h3>
	<slot/>
</section>

<style lang="scss">
	@use 'screen';

	.text-block {
		margin: 3rem 0;
	}
</style>